<footer class="bg-secondary w-screen py-[35px] mt-[90px] lg:gap-[250px] px-5 lg:flex place-content-center">
    <div>
        <img class="h-[50px]" src="./assets/logoWhite.png">
        <div class="text-white text-[24px] font-semibold py-4">Seguici su</div>
        <a href="https://www.facebook.com/NoleggioGommoniAcitrezza/" target="_blank">
            <svg width="32" height="32" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.0034 8.04417C15.0034 4.1777 11.8684 1.04264 8.00189 1.04264C4.13542 1.04264 1.00037 4.1777 1.00037 8.04417C1.00037 11.5387 3.5603 14.4352 6.9079 14.961V10.0687H5.1297V8.04417H6.9079V6.50164C6.9079 4.7472 7.95344 3.7773 9.55254 3.7773C10.3186 3.7773 11.1201 3.9142 11.1201 3.9142V5.63739H10.2368C9.3675 5.63739 9.09556 6.17688 9.09556 6.73138V8.04417H11.0372L10.7272 10.0687H9.09588V14.9616C12.4435 14.4362 15.0034 11.5396 15.0034 8.04417Z"
                    fill="white" />
            </svg>
        </a>
    </div>
    <div class="text-white text-[16px] font-medium">
        <p>Altamarea S.a.s. di Grasso Giovanni &amp; C.</p><br>
        <p>Via Fiera Franca (ex Via Nazionale per Acireale) n. 25/27</p>
        <p>Capo Mulini (prima della rotonda per chi viene da Catania)</p>
        <p>Acireale (Catania) - CAP 95024</p>
        <p>Partita IVA 04115510879</p><br>
        <p> Email: <a href="mailto:altamarea.noleggio@tiscali.it" class="no-line">altamarea.noleggio@tiscali.it</a></p>
        <p> Mobile: <a href="tel:+39 349 8746317" class="no-line">+39 349
                8746317</a></p><br><a routerlink="/privacy-policy" target="_blank" class="no-line"
            href="/privacy-policy"> Privacy Policy | Cookie Policy </a>
    </div>
</footer>